module.exports = __webpack_public_path__ + "img/6.5160dbf5.png";